module.exports = __webpack_public_path__ + "media/components/weather-icon/static/dayheavysnow-39b1d9a7c15c030c70aa21695ffa7eb2.svg";